import {BASE_API} from "../index";

export const ArquivoApi = {
  toggleStatus: async (user_uuid, arquivo_uuid) => {
    let response = await fetch(`${BASE_API}/arquivo/togglestatus`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          arquivo_uuid
        }
      )
    })
    return await response.json();
  },

  create: async (user_uuid, publicacao_uuid, arquivos) => {
    let data = new FormData();
    data.append('user_uuid', user_uuid);
    data.append('publicacao_uuid', publicacao_uuid);
    if (arquivos) {
      let count = 0;
      Object.values(arquivos).map((item) => {
        data.append(`arquivos[${count}]`, item);
        count++;
      })
    }

    let response = await fetch(`${BASE_API}/arquivo/create`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: data
    })
    return await response.json();
  },

  delete: async (user_uuid, arquivo_uuid) => {
    let response = await fetch(`${BASE_API}/arquivo/delete`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(
        {
          user_uuid,
          arquivo_uuid
        }
      )
    })
    return await response.json();
  }
}